<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="handleSave"
        class="rkm-modal"
        extra-large
        ref="RkmModal"
        title="Sinais vitais"
    >
        <template #footer-content>
            <p
                v-rkm-tooltip.hover
                title="Os procedimentos referentes aos sinais vitais preenchidos serão incluídos automaticamente"
            >
                <rkm-icon :icon="['far', 'question-circle']" />
            </p>
        </template>

        <Form
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Enums.
import UnidadeMedida from '@/enums/cadastro/unidadeMedida'

export default {
    components: { Form },
    data: () => ({
        enums: { UnidadeMedida },
        model: null,
    }),
    methods: {
        open(item) {
            if (item) {
                this.model = {
                    id: item.id,
                    pa: item.pa,
                    paUnidadeMedidaId: item.paUnidadeMedidaId,
                    glicemia: item.glicemia,
                    glicemiaUnidadeMedidaId: item.glicemiaUnidadeMedidaId,
                    temperatura: item.temperatura,
                    temperaturaUnidadeMedidaId: item.temperaturaUnidadeMedidaId,
                    pulso: item.pulso,
                    pulsoUnidadeMedidaId: item.pulsoUnidadeMedidaId,
                    respiracao: item.respiracao,
                    respiracaoUnidadeMedidaId: item.respiracaoUnidadeMedidaId,
                    saturacao: item.saturacao,
                    saturacaoUnidadeMedidaId: item.saturacaoUnidadeMedidaId,
                    intensidadeDor: item.intensidadeDor,
                    intensidadeDorUnidadeMedidaId: item.intensidadeDorUnidadeMedidaId,
                    cintura: item.cintura,
                    cinturaUnidadeMedidaId: item.cinturaUnidadeMedidaId,
                }
            } else {
                this.model = {
                    id: null,
                    pa: null,
                    paUnidadeMedidaId: this.enums.UnidadeMedida.MILIMETROS_DE_MERCURIO,
                    glicemia: null,
                    glicemiaUnidadeMedidaId: this.enums.UnidadeMedida.MILIGRAMAS_POR_DECILITRO,
                    temperatura: null,
                    temperaturaUnidadeMedidaId: this.enums.UnidadeMedida.CELSIUS,
                    pulso: null,
                    pulsoUnidadeMedidaId: this.enums.UnidadeMedida.BATIMENTOS_POR_MINUTO,
                    respiracao: null,
                    respiracaoUnidadeMedidaId: this.enums.UnidadeMedida.MOVIMENTOS_POR_MINUTO,
                    saturacao: null,
                    saturacaoUnidadeMedidaId: this.enums.UnidadeMedida.PORCENTAGEM,
                    intensidadeDor: null,
                    intensidadeDorUnidadeMedidaId: this.enums.UnidadeMedida.NIVEL_DE_DOR,
                    cintura: null,
                    cinturaUnidadeMedidaId: this.enums.UnidadeMedida.CENTIMETROS,
                }
            }

            this.$refs.RkmModal.show()
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        saved() {
            this.handleExit()
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>